/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ExamRevisionQuestion200,
  PutApiV1ExamRevisionQuestion400,
  PutApiV1ExamRevisionQuestion401,
  PutApiV1ExamRevisionQuestion404,
  PutApiV1ExamRevisionQuestion500,
  PutApiV1ExamRevisionQuestionMutationRequest,
  PutApiV1ExamRevisionQuestionMutationResponse,
} from "../../types/examRevisionController/PutApiV1ExamRevisionQuestion.ts";
import { botExamLangTranslationQuestionViewModelSchema } from "../botExamLangTranslationQuestionViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1ExamRevisionQuestion200Schema = z
  .number()
  .int() as unknown as ToZod<PutApiV1ExamRevisionQuestion200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ExamRevisionQuestion400Schema =
  z.any() as unknown as ToZod<PutApiV1ExamRevisionQuestion400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ExamRevisionQuestion401Schema =
  z.any() as unknown as ToZod<PutApiV1ExamRevisionQuestion401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ExamRevisionQuestion404Schema =
  z.any() as unknown as ToZod<PutApiV1ExamRevisionQuestion404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1ExamRevisionQuestion500Schema =
  z.any() as unknown as ToZod<PutApiV1ExamRevisionQuestion500>;

export const putApiV1ExamRevisionQuestionMutationRequestSchema = z.lazy(
  () => botExamLangTranslationQuestionViewModelSchema,
) as unknown as ToZod<PutApiV1ExamRevisionQuestionMutationRequest>;

export const putApiV1ExamRevisionQuestionMutationResponseSchema = z.lazy(
  () => putApiV1ExamRevisionQuestion200Schema,
) as unknown as ToZod<PutApiV1ExamRevisionQuestionMutationResponse>;
